module.exports = __webpack_public_path__ + "img/python.dfc7165a.png";